var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.groupId != null && _vm.groupId != '')?_c('mgt-people',{attrs:{"show-max":"5","group-id":_vm.groupId,"fetch-image":"true","view":"oneLine"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }